class HotelTabs {
  to = { name: '' }

  title = ''

  key = ''

  isEditable = true

  isOptions = false

  requiredFields = null

  constructor (to = { name: '' }, title, key, isEditable, isOptions, requiredFields) {
    this.to = to
    this.title = title
    this.key = key
    this.isEditable = isEditable
    this.isOptions = isOptions
    this.requiredFields = requiredFields
  }
}

export default [
  new HotelTabs({ name: 'hotel' }, 'Отель', '', true, false, ['hotel']),
  new HotelTabs({ name: 'roomTypes' }, 'Типы комнат', '', true, false, ['roomTypes']),
  new HotelTabs({ name: 'rooms' }, 'Комнаты', '', false, false, ['rooms'])
]
